var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "home" },
    [
      _c("v-row", [
        _c("div", [
          _c("h2", { staticClass: "page-title-bar" }, [
            _c("i", { staticClass: "ico ico-overview" }),
            _vm._v(_vm._s(_vm.$t("Overview")) + " ")
          ])
        ]),
        _c(
          "div",
          {
            staticClass: "label-txt",
            staticStyle: { "margin-left": "10px", "margin-top": "10px" }
          },
          [
            _c("span", [_vm._v(_vm._s(_vm.LastModifiedDate))]),
            _c("span", { staticStyle: { "margin-left": "5px" } }, [
              _vm._v("(" + _vm._s(_vm.LastTimezone) + ")")
            ])
          ]
        )
      ]),
      _c("div", [
        _c("div", { staticClass: "state-info" }, [
          _c("ul", [
            _c("li", { staticClass: "state-danger" }, [
              _vm._v(_vm._s(_vm.$t("DANGER")))
            ]),
            _c("li", { staticClass: "state-caution" }, [
              _vm._v(_vm._s(_vm.$t("CAUTION")))
            ]),
            _c("li", { staticClass: "state-stable" }, [
              _vm._v(_vm._s(_vm.$t("STABLE")))
            ])
          ])
        ]),
        _c("div", { staticClass: "main-layout layout01" }, [
          _c("div", { staticClass: "main-section" }, [
            _c("h3", { staticClass: "tit-section" }, [
              _vm._v(_vm._s(_vm.$t("Label Status")))
            ]),
            _c(
              "div",
              { staticClass: "group" },
              [
                _c(
                  "v-btn",
                  { staticClass: "stateBox" },
                  [
                    _c(
                      "router-link",
                      {
                        attrs: { to: {} },
                        nativeOn: {
                          click: function($event) {
                            $event.preventDefault()
                            return _vm.goDirectPage(
                              "2100",
                              {
                                name: "Label Info",
                                params: { status: "SUCCESS" }
                              },
                              _vm.updatedLabelCount
                            )
                          }
                        }
                      },
                      [
                        _c("dl", [
                          _c("dt", [_vm._v(_vm._s(_vm.$t("Update Success")))]),
                          _c("dd", [
                            _c("p", [
                              _c("strong", [
                                _vm._v(_vm._s(_vm.percentUpdateSuccess) + "%")
                              ])
                            ]),
                            _c("p", [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm._f("currency")(_vm.updatedLabelCount)
                                  ) +
                                  "ea / " +
                                  _vm._s(
                                    _vm._f("currency")(
                                      _vm.totalUpdatedLabelCount
                                    )
                                  ) +
                                  "ea "
                              )
                            ])
                          ])
                        ])
                      ]
                    )
                  ],
                  1
                ),
                _c(
                  "v-btn",
                  { staticClass: "stateBox" },
                  [
                    _c(
                      "router-link",
                      {
                        attrs: { to: {} },
                        nativeOn: {
                          click: function($event) {
                            $event.preventDefault()
                            return _vm.goDirectPage(
                              "2100",
                              {
                                name: "Label Info",
                                params: { status: "PROCESSING" }
                              },
                              _vm.inProgressLabelCount
                            )
                          }
                        }
                      },
                      [
                        _c("dl", [
                          _c("dt", [_vm._v(_vm._s(_vm.$t("Processing")))]),
                          _c("dd", [
                            _c("p", [
                              _c("strong", [
                                _vm._v(_vm._s(_vm.percentProcessing) + "%")
                              ])
                            ]),
                            _c("p", [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm._f("currency")(_vm.inProgressLabelCount)
                                  ) +
                                  "ea / " +
                                  _vm._s(
                                    _vm._f("currency")(
                                      _vm.totalUpdatedLabelCount
                                    )
                                  ) +
                                  "ea "
                              )
                            ])
                          ])
                        ])
                      ]
                    )
                  ],
                  1
                ),
                _c(
                  "v-btn",
                  { ref: "UpdateFailure", staticClass: "stateBox" },
                  [
                    _c(
                      "router-link",
                      {
                        attrs: { to: {} },
                        nativeOn: {
                          click: function($event) {
                            $event.preventDefault()
                            _vm.goDirectPage(
                              "2100",
                              {
                                name: "Label Info",
                                params: { status: "TIMEOUT" }
                              },
                              _vm.notUpdatedLabelCount,
                              _vm.problemStoreVisible("updateFailure")
                            )
                          }
                        }
                      },
                      [
                        _c("dl", [
                          _c("dt", [_vm._v(_vm._s(_vm.$t("Update Failure")))]),
                          _c("dd", [
                            _c("p", [
                              _c("strong", [
                                _vm._v(_vm._s(_vm.percentUpdateFailure) + "%")
                              ])
                            ]),
                            _c("p", [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm._f("currency")(_vm.notUpdatedLabelCount)
                                  ) +
                                  "ea / " +
                                  _vm._s(
                                    _vm._f("currency")(
                                      _vm.totalUpdatedLabelCount
                                    )
                                  ) +
                                  "ea "
                              )
                            ])
                          ])
                        ])
                      ]
                    )
                  ],
                  1
                ),
                _c(
                  "v-btn",
                  { staticClass: "stateBox" },
                  [
                    _c(
                      "router-link",
                      {
                        attrs: { to: {} },
                        nativeOn: {
                          click: function($event) {
                            $event.preventDefault()
                            return _vm.goDirectPage(
                              "3100",
                              { name: "Product Info" },
                              _vm.totalProductCount
                            )
                          }
                        }
                      },
                      [
                        _c("dt", [_vm._v(_vm._s(_vm.$t("Total Product")))]),
                        _c("dd", [
                          _c("p", [
                            _c("strong", [
                              _vm._v(
                                _vm._s(
                                  _vm._f("currency")(_vm.totalProductCount)
                                )
                              )
                            ])
                          ])
                        ])
                      ]
                    )
                  ],
                  1
                ),
                _c(
                  "dl",
                  {
                    staticClass: "stateBox",
                    staticStyle: { "margin-left": "10px" }
                  },
                  [
                    _c("dt", [
                      _vm._v(_vm._s(_vm.$t("Total Assigned Product")))
                    ]),
                    _c("dd", [
                      _c("p", [
                        _c("strong", [
                          _vm._v(
                            _vm._s(
                              _vm._f("currency")(_vm.totalAssignedProductCount)
                            )
                          )
                        ])
                      ])
                    ])
                  ]
                ),
                _c(
                  "v-btn",
                  { staticClass: "stateBox ml_10" },
                  [
                    _c(
                      "router-link",
                      {
                        attrs: { to: {} },
                        nativeOn: {
                          click: function($event) {
                            $event.preventDefault()
                            return _vm.goDirectPage(
                              "2100",
                              { name: "Label Info", params: { status: null } },
                              _vm.totalLabelCount
                            )
                          }
                        }
                      },
                      [
                        _c("dl", [
                          _c("dt", [_vm._v(_vm._s(_vm.$t("Total Label")))]),
                          _c("dd", [
                            _c("p", [
                              _c("strong", [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("currency")(_vm.totalLabelCount)
                                  )
                                )
                              ])
                            ])
                          ])
                        ])
                      ]
                    )
                  ],
                  1
                )
              ],
              1
            )
          ]),
          _vm.CUSTOMER === "LCL" || _vm.CUSTOMER === "METRO"
            ? _c(
                "div",
                { staticClass: "main-section" },
                [
                  _c("h3", { staticClass: "tit-section" }, [
                    _vm._v(_vm._s(_vm.$t("Exception Status")))
                  ]),
                  _c(
                    "v-btn",
                    {
                      ref: "LowBattery",
                      staticClass: "stateBox",
                      staticStyle: { "margin-bottom": "20px", width: "100%" }
                    },
                    [
                      _c(
                        "router-link",
                        {
                          attrs: { to: {} },
                          nativeOn: {
                            click: function($event) {
                              $event.preventDefault()
                              _vm.goDirectPage(
                                "2100",
                                {
                                  name: "Label Info",
                                  params: { battery: "VERYGOOD" }
                                },
                                _vm.veryGoodBatteryCount,
                                _vm.problemStoreVisible("verygoodBattery")
                              )
                            }
                          }
                        },
                        [
                          _c(
                            "dt",
                            {
                              staticStyle: {
                                "border-bottom": "1px solid #197FE5"
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("Battery")))]
                          ),
                          _c(
                            "dd",
                            { staticStyle: { width: "25%", float: "right" } },
                            [
                              _c("p", [
                                _c(
                                  "strong",
                                  { staticStyle: { color: "#197FE5" } },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm._f("currency")(
                                          _vm.veryGoodBatteryCount
                                        )
                                      )
                                    )
                                  ]
                                )
                              ]),
                              _c("p", [_vm._v(" 50~100% ")])
                            ]
                          )
                        ]
                      ),
                      _c(
                        "router-link",
                        {
                          attrs: { to: {} },
                          nativeOn: {
                            click: function($event) {
                              $event.preventDefault()
                              _vm.goDirectPage(
                                "2100",
                                {
                                  name: "Label Info",
                                  params: { battery: "GOOD" }
                                },
                                _vm.goodBatteryCount,
                                _vm.problemStoreVisible("goodBattery")
                              )
                            }
                          }
                        },
                        [
                          _c("dt", {
                            staticStyle: {
                              "border-bottom": "1px solid #64B86A"
                            }
                          }),
                          _c(
                            "dd",
                            { staticStyle: { width: "25%", float: "right" } },
                            [
                              _c("p", [
                                _c(
                                  "strong",
                                  { staticStyle: { color: "#64B86A" } },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm._f("currency")(_vm.goodBatteryCount)
                                      )
                                    )
                                  ]
                                )
                              ]),
                              _c("p", [_vm._v(" 25~49% ")])
                            ]
                          )
                        ]
                      ),
                      _c(
                        "router-link",
                        {
                          attrs: { to: {} },
                          nativeOn: {
                            click: function($event) {
                              $event.preventDefault()
                              _vm.goDirectPage(
                                "2100",
                                {
                                  name: "Label Info",
                                  params: { battery: "LOW" }
                                },
                                _vm.lowBatteryCount,
                                _vm.problemStoreVisible("lowBattery")
                              )
                            }
                          }
                        },
                        [
                          _c("dt", {
                            staticStyle: {
                              "border-bottom": "1px solid #F5B45F"
                            }
                          }),
                          _c(
                            "dd",
                            { staticStyle: { width: "25%", float: "right" } },
                            [
                              _c("p", [
                                _c(
                                  "strong",
                                  { staticStyle: { color: "#F5B45F" } },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm._f("currency")(_vm.lowBatteryCount)
                                      )
                                    )
                                  ]
                                )
                              ]),
                              _c("p", [_vm._v(" 10~24% ")])
                            ]
                          )
                        ]
                      ),
                      _c(
                        "router-link",
                        {
                          attrs: { to: {} },
                          nativeOn: {
                            click: function($event) {
                              $event.preventDefault()
                              _vm.goDirectPage(
                                "2100",
                                {
                                  name: "Label Info",
                                  params: { battery: "REPLACE" }
                                },
                                _vm.replaceBatteryCount,
                                _vm.problemStoreVisible("replaceBattery")
                              )
                            }
                          }
                        },
                        [
                          _c("dt", {
                            staticStyle: {
                              "border-bottom": "1px solid #E27070"
                            }
                          }),
                          _c(
                            "dd",
                            { staticStyle: { width: "25%", float: "right" } },
                            [
                              _c("p", [
                                _c(
                                  "strong",
                                  { staticStyle: { color: "#E27070" } },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm._f("currency")(
                                          _vm.replaceBatteryCount
                                        )
                                      )
                                    )
                                  ]
                                )
                              ]),
                              _c("p", [_vm._v(" 0~9% ")])
                            ]
                          )
                        ]
                      )
                    ],
                    1
                  ),
                  _c("br"),
                  _c(
                    "div",
                    { staticClass: "group", staticStyle: { width: "100%" } },
                    [
                      _c(
                        "v-btn",
                        {
                          ref: "LabelOffline",
                          staticClass: "stateBox",
                          staticStyle: { width: "31.5%" }
                        },
                        [
                          _c(
                            "router-link",
                            {
                              attrs: { to: {} },
                              nativeOn: {
                                click: function($event) {
                                  $event.preventDefault()
                                  _vm.goDirectPage(
                                    "2100",
                                    {
                                      name: "Label Info",
                                      params: { network: "false" }
                                    },
                                    _vm.offlineLabelCount,
                                    _vm.problemStoreVisible("labelOffline")
                                  )
                                }
                              }
                            },
                            [
                              _c("dt", [_vm._v(_vm._s(_vm.$t("Offline")))]),
                              _c("dd", [
                                _c("p", [
                                  _vm.offlineLabelStatus !== "N/A"
                                    ? _c("strong", [
                                        _vm._v(
                                          _vm._s(
                                            _vm._f("currency")(
                                              _vm.offlineLabelStatus
                                            )
                                          )
                                        )
                                      ])
                                    : _c("strong", [
                                        _vm._v(_vm._s(_vm.offlineLabelStatus))
                                      ])
                                ])
                              ])
                            ]
                          )
                        ],
                        1
                      ),
                      _c(
                        "v-btn",
                        {
                          ref: "BadSignal",
                          staticClass: "stateBox",
                          staticStyle: { width: "31.5%" }
                        },
                        [
                          _c(
                            "router-link",
                            {
                              attrs: { to: {} },
                              nativeOn: {
                                click: function($event) {
                                  $event.preventDefault()
                                  _vm.goDirectPage(
                                    "2100",
                                    {
                                      name: "Label Info",
                                      params: { signal: "BAD" }
                                    },
                                    _vm.badSignalLabelCount,
                                    _vm.problemStoreVisible("badSignal")
                                  )
                                }
                              }
                            },
                            [
                              _c("dt", [
                                _vm._v(_vm._s(_vm.$t("Bad RF quality")))
                              ]),
                              _c("dd", [
                                _c("p", [
                                  _c("strong", [
                                    _vm._v(
                                      _vm._s(
                                        _vm._f("currency")(
                                          _vm.badSignalLabelCount
                                        )
                                      )
                                    )
                                  ])
                                ])
                              ])
                            ]
                          )
                        ],
                        1
                      ),
                      _c(
                        "v-btn",
                        {
                          ref: "Misused",
                          staticClass: "stateBox",
                          staticStyle: { width: "31.5%", "margin-left": "10px" }
                        },
                        [
                          _c(
                            "router-link",
                            {
                              attrs: { to: {} },
                              nativeOn: {
                                click: function($event) {
                                  $event.preventDefault()
                                  _vm.goDirectPage(
                                    "2100",
                                    {
                                      name: "Label Info",
                                      params: { misusedLabelType: "All" }
                                    },
                                    _vm.misUsedLabelCount,
                                    _vm.problemStoreVisible("misused")
                                  )
                                }
                              }
                            },
                            [
                              _c("dt", [_vm._v(_vm._s(_vm.$t("Misused")))]),
                              _c("dd", [
                                _c("p", [
                                  _c("strong", [
                                    _vm._v(
                                      _vm._s(
                                        _vm._f("currency")(
                                          _vm.misUsedLabelCount
                                        )
                                      )
                                    )
                                  ])
                                ])
                              ])
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.CUSTOMER !== "LCL" && _vm.CUSTOMER !== "METRO"
            ? _c("div", { staticClass: "main-section" }, [
                _c("h3", { staticClass: "tit-section" }, [
                  _vm._v(_vm._s(_vm.$t("Exception Status")))
                ]),
                _c(
                  "div",
                  { staticClass: "group" },
                  [
                    _c(
                      "v-btn",
                      { ref: "LabelOffline", staticClass: "stateBox" },
                      [
                        _c(
                          "router-link",
                          {
                            attrs: { to: {} },
                            nativeOn: {
                              click: function($event) {
                                $event.preventDefault()
                                _vm.goDirectPage(
                                  "2100",
                                  {
                                    name: "Label Info",
                                    params: { network: "false" }
                                  },
                                  _vm.offlineLabelCount,
                                  _vm.problemStoreVisible("labelOffline")
                                )
                              }
                            }
                          },
                          [
                            _c("dt", [_vm._v(_vm._s(_vm.$t("Label Offline")))]),
                            _c("dd", [
                              _c("p", [
                                _vm.offlineLabelStatus !== "N/A"
                                  ? _c("strong", [
                                      _vm._v(
                                        _vm._s(
                                          _vm._f("currency")(
                                            _vm.offlineLabelStatus
                                          )
                                        )
                                      )
                                    ])
                                  : _c("strong", [
                                      _vm._v(_vm._s(_vm.offlineLabelStatus))
                                    ])
                              ])
                            ])
                          ]
                        )
                      ],
                      1
                    ),
                    _c(
                      "v-btn",
                      { ref: "LowBattery", staticClass: "stateBox" },
                      [
                        _c(
                          "router-link",
                          {
                            attrs: { to: {} },
                            nativeOn: {
                              click: function($event) {
                                $event.preventDefault()
                                _vm.goDirectPage(
                                  "2100",
                                  {
                                    name: "Label Info",
                                    params: { battery: "BAD" }
                                  },
                                  _vm.lowBatteryCount,
                                  _vm.problemStoreVisible("lowBattery")
                                )
                              }
                            }
                          },
                          [
                            _c("dt", [_vm._v(_vm._s(_vm.$t("Low Battery")))]),
                            _c("dd", [
                              _c("p", [
                                _c("strong", [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("currency")(_vm.lowBatteryCount)
                                    )
                                  )
                                ])
                              ])
                            ])
                          ]
                        )
                      ],
                      1
                    ),
                    _c(
                      "v-btn",
                      { ref: "BadSignal", staticClass: "stateBox" },
                      [
                        _c(
                          "router-link",
                          {
                            attrs: { to: {} },
                            nativeOn: {
                              click: function($event) {
                                $event.preventDefault()
                                _vm.goDirectPage(
                                  "2100",
                                  {
                                    name: "Label Info",
                                    params: { signal: "BAD" }
                                  },
                                  _vm.badSignalLabelCount,
                                  _vm.problemStoreVisible("badSignal")
                                )
                              }
                            }
                          },
                          [
                            _c("dt", [_vm._v(_vm._s(_vm.$t("Bad Signal")))]),
                            _c("dd", [
                              _c("p", [
                                _c("strong", [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("currency")(
                                        _vm.badSignalLabelCount
                                      )
                                    )
                                  )
                                ])
                              ])
                            ])
                          ]
                        )
                      ],
                      1
                    ),
                    _c(
                      "v-btn",
                      { ref: "Misused", staticClass: "stateBox" },
                      [
                        _c(
                          "router-link",
                          {
                            attrs: { to: {} },
                            nativeOn: {
                              click: function($event) {
                                $event.preventDefault()
                                _vm.goDirectPage(
                                  "2100",
                                  {
                                    name: "Label Info",
                                    params: { misusedLabelType: "All" }
                                  },
                                  _vm.misUsedLabelCount,
                                  _vm.problemStoreVisible("misused")
                                )
                              }
                            }
                          },
                          [
                            _c("dt", [_vm._v(_vm._s(_vm.$t("Misused")))]),
                            _c("dd", [
                              _c("p", [
                                _c("strong", [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("currency")(_vm.misUsedLabelCount)
                                    )
                                  )
                                ])
                              ])
                            ])
                          ]
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ])
            : _vm._e()
        ]),
        _c("div", { staticClass: "main-layout layout02" }, [
          _c("div", { staticClass: "main-section" }, [
            _c("h3", { staticClass: "tit-section" }, [
              _vm._v(_vm._s(_vm.$t("Gateway Status")))
            ]),
            _c(
              "div",
              { staticClass: "group" },
              [
                _c("v-btn", { ref: "GatewayStatus", staticClass: "stateBox" }, [
                  _c(
                    "dl",
                    [
                      _c(
                        "router-link",
                        {
                          attrs: { to: {} },
                          nativeOn: {
                            click: function($event) {
                              $event.preventDefault()
                              _vm.goDirectPage(
                                "4100",
                                {
                                  name: "Gateway Info",
                                  params: { network: "offline" }
                                },
                                _vm.offlineGwCount,
                                _vm.problemStoreVisible("gatewayOffline")
                              )
                            }
                          }
                        },
                        [
                          _c("dt", [_vm._v(_vm._s(_vm.$t("Gateway Offline")))]),
                          _c("dd", [
                            _c("p", [
                              _c("strong", [
                                _vm._v(
                                  _vm._s(_vm._f("currency")(_vm.offlineGwCount))
                                )
                              ])
                            ])
                          ])
                        ]
                      )
                    ],
                    1
                  )
                ]),
                _c("v-btn", { staticClass: "stateBox" }, [
                  _c(
                    "dl",
                    [
                      _c(
                        "router-link",
                        {
                          attrs: { to: {} },
                          nativeOn: {
                            click: function($event) {
                              $event.preventDefault()
                              return _vm.goDirectPage(
                                "4100",
                                {
                                  name: "Gateway Info",
                                  params: { network: "all" }
                                },
                                _vm.totalGwCount
                              )
                            }
                          }
                        },
                        [
                          _c("dt", [_vm._v(_vm._s(_vm.$t("Total Gateway")))]),
                          _c("dd", [
                            _c("p", [
                              _c("strong", [
                                _vm._v(
                                  _vm._s(_vm._f("currency")(_vm.totalGwCount))
                                )
                              ])
                            ])
                          ])
                        ]
                      )
                    ],
                    1
                  )
                ])
              ],
              1
            )
          ]),
          _c("div", { staticClass: "main-section" }, [
            _c("h3", { staticClass: "tit-section" }, [
              _vm._v(_vm._s(_vm.$t("Update Status")))
            ]),
            _c(
              "div",
              {
                staticClass: "graphBox",
                style: { display: _vm.progressBarShow },
                attrs: { id: "progress-linear" }
              },
              [
                _c("h4", { staticClass: "tit-sub" }, [
                  _vm._v(_vm._s(_vm.$t("Latest Update Status")))
                ]),
                _c(
                  "div",
                  { staticClass: "lineBar" },
                  [
                    _c("v-slider", {
                      staticClass: "linear-graph",
                      attrs: {
                        readonly: "",
                        dense: "",
                        "hide-details": "",
                        "track-color": "#ffffff"
                      },
                      model: {
                        value: _vm.percentProgress,
                        callback: function($$v) {
                          _vm.percentProgress = $$v
                        },
                        expression: "percentProgress"
                      }
                    }),
                    _c("div", { staticClass: "bar_data" }, [
                      _c("strong", [_vm._v(_vm._s(_vm.percentProgress) + "%")]),
                      _c("p", [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm._f("currency")(_vm.lastUpdateInprogressCount)
                            ) +
                            "ea / " +
                            _vm._s(
                              _vm._f("currency")(_vm.lastUpdatetotalCount)
                            ) +
                            "ea "
                        )
                      ])
                    ])
                  ],
                  1
                )
              ]
            ),
            _c(
              "div",
              { staticClass: "graphBox" },
              [
                _c("h4", { staticClass: "tit-sub" }, [
                  _vm._v(_vm._s(_vm.$t("Total Update Order")))
                ]),
                _c("mixChart", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.progressBarShow === "none",
                      expression: "progressBarShow === 'none'"
                    }
                  ],
                  attrs: { height: 250, updateStatus: _vm.updateStatus }
                }),
                _c("mixChart", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.progressBarShow === "block",
                      expression: "progressBarShow === 'block'"
                    }
                  ],
                  attrs: { height: 160, updateStatus: _vm.updateStatus }
                })
              ],
              1
            )
          ])
        ])
      ]),
      _c(
        "v-dialog",
        {
          attrs: { width: "800" },
          on: {
            "click:outside": function($event) {
              _vm.problemDialog = false
            }
          },
          model: {
            value: _vm.problemDialog,
            callback: function($$v) {
              _vm.problemDialog = $$v
            },
            expression: "problemDialog"
          }
        },
        [
          _c(
            "v-card",
            { staticClass: "popup add_store_popup" },
            [
              _c("h3", { staticClass: "page-title-bar" }, [
                _c("i", { staticClass: "ico ico-overview" }),
                _vm._v(_vm._s(_vm.$t("Abnormal Store")) + " ")
              ]),
              _c("v-data-table", {
                staticClass: "tbl-type01 mt-10",
                attrs: {
                  headers: _vm.translateHeaders(_vm.ProblemHeaders),
                  items: _vm.ProblemItems,
                  "hide-default-footer": true,
                  "item-key": "id"
                },
                on: {
                  "page-count": function($event) {
                    _vm.pageCount = $event
                  }
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "item.link",
                      fn: function(ref) {
                        var item = ref.item
                        return [
                          _c(
                            "v-btn",
                            {
                              attrs: { text: "" },
                              on: {
                                click: function($event) {
                                  return _vm.goProblemLink(item)
                                }
                              }
                            },
                            [
                              _c("img", {
                                attrs: {
                                  src: require("@/assets/img/ico_link.png"),
                                  alt: "aaa"
                                }
                              })
                            ]
                          )
                        ]
                      }
                    }
                  ],
                  null,
                  true
                )
              }),
              _c(
                "v-card-actions",
                { staticClass: "d-flex justify-center" },
                [
                  _c(
                    "v-btn",
                    {
                      staticClass: "btn",
                      attrs: { text: "", icon: "" },
                      on: {
                        click: function($event) {
                          _vm.problemDialog = false
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("Close")))]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }